const lang = {
    actionButton: {
        confirm: 'ตกลง',
        cancel: 'ยกเลิก',
    },
};
export default lang;
